/**
 * localStorage 汎用アクセスサービス
 * JSON parse 失敗時は安全に fallback する
 */

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  /** JSON値を取得（parse失敗時は fallback を返す） */
  getItem<T>(key: string, fallback: T | null = null): T | null {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return fallback;
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  }

  /** JSON値を保存 */
  setItem<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // 容量超過等は無視
    }
  }

  /** キーを削除 */
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // 無視
    }
  }

  /** 指定 prefix で始まるキーをすべて削除 */
  clearByPrefix(prefix: string): void {
    try {
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k?.startsWith(prefix)) {
          keysToRemove.push(k);
        }
      }
      keysToRemove.forEach(k => localStorage.removeItem(k));
    } catch {
      // 無視
    }
  }
}
